<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <legend>Доставка заказов</legend>
                </div>
                <div class="col-12">
                    <form @submit.prevent="addOrderBySferaNumber" class="form-row">
                        <div class="form-group col-lg-6">
                            <date-picker class="w-100" v-model="deliveryDate"
                                         valueType="date"
                                         :input-attr="{required:true}"
                                         :first-day-of-week="1" lang="ru"></date-picker>
                        </div>
                        <div class="form-group col-lg-6">
                            <div class="input-group">
                                <input type="number" class="form-control" placeholder="Номер сферы" v-model="sferaNumber" required
                                       ref="inputSferaNumber">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="submit">Добавить</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container mt-5">
            <div v-for="orders in customerOrders">
                <partner-delivery :orders="orders" @remove="removeOrder" :allow-deleting="true"></partner-delivery>
            </div>
        </div>
        <div class="container mt-5" v-if="orders.length">
            <div class="">
                <legend>Сохранить доставку</legend>
                <form @submit.prevent="saveDelivery">
                    <div class="form-group row">
                        <div class="col-lg-6">
                            <label>Курьер</label>
                            <div>
                                <v-select v-model="courier" label="Reception" :filterable="false"
                                          :options="couriers">
                                    <template slot="no-options">
                                        начните вводить курьера...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.Reception }} ({{option.Fname}} {{option.Lname}})
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.Login }} ({{option.Fname}} {{option.Lname}})
                                        </div>
                                    </template>
                                    <template #search="{attributes, events}">
                                        <input
                                                class="vs__search"
                                                :required="!courier"
                                                v-bind="attributes"
                                                v-on="events"
                                                v-on:keydown.enter.prevent
                                        />
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <label>Дата доставки</label>
                            <div>
                                <date-picker class="w-100" v-model="deliveryDate"
                                             valueType="date"
                                             :input-attr="{required:true}"
                                             :first-day-of-week="1" lang="ru"></date-picker>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Сохранить доставку</button>
                </form>
            </div>
        </div>
        <div class="container mt-5" v-else>
            <legend>Неназначенные заказы на доставку</legend>
            <table class="table table-bordered ">
                <tbody>
                <tr v-for="Reception in Receptions">
                    <td class="align-middle">{{Reception.PartnerTourName}}</td>
                    <td class="align-middle">{{Reception.Reception}}</td>
                    <td class="align-middle">{{Reception.OrderIDs.length}}</td>
                    <td width="350">
                      <div class="d-flex flex-row">
                        <v-select v-model="Reception.Courier" label="Login" :filterable="false"
                                  class="float-left"
                                  style="width: 250px;"
                                  :options="couriers">
                          <template slot="no-options">
                            начните вводить...
                          </template>
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              {{ getCourierName(option) }}
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              {{ getCourierName(option) }}
                            </div>
                          </template>
                        </v-select>
                        <button @click.prevent="createDeliveryFromCollection(Reception)" type="button" class="ml-2 btn btn-sm btn-outline-info">Назначить</button>
                      </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <button class="btn btn-outline-success mb-5" @click="createDeliveryFromCollection(null)">Назначить</button>
        </div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import { get, post } from '@/admin/services/api/http-utils';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;
const type = 'partner';

export default {
  components: {
    DatePicker,
    PartnerDelivery,
  },
  data() {
    return {
      sferaNumber: null,
      orders: [],
      courier: null,
      existOrders: [],
      couriers: [],
      deliveryDate: new Date(),
      Receptions: [],
    };
  },
  computed: {
    customerOrders() {
      console.log('this.orders', this.orders);
      return _.groupBy(
        _.map(
          this.orders, item => Object.assign({ isExist: this.isExist(item.order.Id) }, item),
        ),
        item => item.customer.Id,
      );
    },
  },
  created() {
    this.fetchCouriers();
    this.fetchReceptions();
  },
  methods: {
    async fetchReceptions() {
      try {
        const data = await get(`${url}/unassigned-delivery-orders`);
        this.Receptions = data.data;
        console.log(this.Receptions);
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toasted.show(error.response.data, { type: 'error' });
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    async addOrderBySferaNumber() {
      const data = await get(`${url}/order-by-sfera-number/${type}/${this.sferaNumber}`);
      this.addOrder(data);
    },
    async addOrdersByIDs(ids) {
      const data = await get(`${url}/orders-by-ids/${type}/${ids.join(',')}`);
      _.each(data.data, o => this.addOrder({ data: o }));
      // console.log(this.$refs.datePicker);
    },
    addOrder(data) {
      try {
        if (_.findIndex(this.orders, data.data) !== -1) {
          this.$toasted.show('Заказ уже есть в списке', { type: 'info' });
        } else {
          this.orders.push(data.data);
        }
        this.sferaNumber = null;
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toasted.show(error.response.data, { type: 'error' });
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    removeOrder(Id) {
      const key = _.findKey(this.orders, o => o.order.Id === Id);
      this.orders.splice(key, 1);
    },
    async saveDelivery() {
      try {
        await post(url, {
          OrderIDs: this.getOrderIDs(),
          CourierId: this.courier.Id,
          DeliveryDate: this.deliveryDate,
        });
        this.existOrders = [];
        this.$toasted.show('Доставка сохранена', { type: 'success' });
        this.fetchReceptions();
      } catch (error) {
        if (error.response && error.response.data) {
          if (error.response.status === 409) {
            this.existOrders = _.map(error.response.data, 'OrderItemId');
            this.$toasted.show('Некоторые заказы уже есть в доставке', { type: 'error' });
          } else {
            this.$toasted.show(error.response.data, { type: 'error' });
          }
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    getOrderIDs() {
      return _.map(this.orders, o => o.order.Id);
    },
    isExist(OrderId) {
      return this.existOrders.includes(OrderId);
    },
    async fetchCouriers() {
      const { data } = await get(`${url}/couriers`);
      this.couriers = data;
    },
    async createDeliveryFromCollection(reception) {
      try {
        if (reception) {
          await post(`${url}/create-delivery-from-collection`, { Receptions: [reception], DeliveryDate: this.deliveryDate });
        } else {
          await post(`${url}/create-delivery-from-collection`, { Receptions: this.Receptions, DeliveryDate: this.deliveryDate });
        }
        this.$toasted.show('Доставка сохранена', { type: 'success' });
        this.fetchReceptions();
      } catch (error) {
        if (error.response && error.response.data) {
          if (error.response.status === 409) {
            this.existOrders = _.map(error.response.data, 'OrderItemId');
            this.$toasted.show('Некоторые заказы уже есть в доставке', { type: 'error' });
          } else {
            this.$toasted.show(error.response.data, { type: 'error' });
          }
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    redoCourier(Reception, Courier) {
      if (!confirm('Назначить курьера всему объезду?')) {
        return;
      }
      this.Receptions.map((o) => {
        if (o.PartnerTourName === Reception.PartnerTourName) {
          o.Courier = Courier;
        }
        return o;
      });
    },
    getCourierName(option) {
      if (option.Reception) {
        return option.Reception;
      } if (option.Lname || option.Fname) {
        return `${option.Lname} ${option.Fname}`;
      } if (option.Login) {
        return option.Login;
      } if (option.Email) {
        return option.Email;
      }
      return option.Id;
    },
  },
};
</script>
